(function () {
  if (window.__shuliWelcome) return;
  window.__shuliWelcome = true;

  var CODE = 'WELCOME5';
  var KEY = 'shuli-welcome';
  var DELAY_MS = 4000;
  var SNOOZE_DAYS = 14;
  var path = location.pathname;
  if (/^\/(cart|checkouts?|account|challenge|password)/.test(path)) return;
  if (window.Shopify && Shopify.designMode) return;

  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  var params = new URLSearchParams(location.search);
  var justPosted = params.get('customer_posted') === 'true' && location.hash.indexOf('shuli-welcome') !== -1;
  var state = get();
  if (!justPosted) {
    if (state.subscribed) return;
    if (state.dismissed && Date.now() - state.dismissed < SNOOZE_DAYS * 864e5) return;
  }

  var css =
    '.sw-overlay{position:fixed;inset:0;background:rgba(43,30,20,.55);z-index:9995;display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .25s}' +
    '.sw-overlay.sw-open{opacity:1}' +
    '.sw-box{position:relative;width:100%;max-width:420px;aspect-ratio:1/1;max-height:calc(100vh - 32px);overflow:auto;background:#fff;border:1px solid #e6d9c6;border-radius:10px;box-shadow:0 18px 50px rgba(0,0,0,.25);display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:36px 32px;color:#3b2a1e;font-family:inherit;transform:translateY(10px);transition:transform .25s}' +
    '.sw-open .sw-box{transform:none}' +
    '.sw-box:before{content:"";position:absolute;inset:8px;border:1px solid #d8c3a0;border-radius:6px;pointer-events:none}' +
    '.sw-x{position:absolute;top:12px;right:12px;width:36px;height:36px;border:0;background:none;font-size:26px;line-height:1;color:#3b2a1e;cursor:pointer;border-radius:50%;z-index:1}' +
    '.sw-x:hover{background:#f3ece1}.sw-x:focus-visible,.sw-btn:focus-visible,.sw-no:focus-visible{outline:2px solid #8c5a2b;outline-offset:2px}' +
    '.sw-brand{font-size:12px;letter-spacing:.28em;text-transform:uppercase;color:#8c5a2b;margin:0 0 10px}' +
    '.sw-h{font-size:30px;line-height:1.15;margin:0 0 10px;color:#3b2a1e;font-weight:400}' +
    '.sw-h b{display:block;font-size:44px;color:#8c5a2b;font-weight:600;margin-top:2px}' +
    '.sw-p{font-size:15px;line-height:1.5;margin:0 0 18px;color:#5a4636;max-width:300px}' +
    '.sw-form{width:100%;max-width:310px;display:flex;flex-direction:column;gap:10px}' +
    '.sw-in{width:100%;height:46px;border:1px solid #c9b391;border-radius:4px;padding:0 14px;font-size:16px;color:#3b2a1e;background:#fff;box-sizing:border-box}' +
    '.sw-in:focus{outline:2px solid #8c5a2b;outline-offset:0;border-color:#8c5a2b}' +
    '.sw-btn{height:46px;border:0;border-radius:40px;background:#8c5a2b;color:#fff;font-size:15px;letter-spacing:.06em;cursor:pointer;font-family:inherit}' +
    '.sw-btn:hover{background:#74481f}' +
    '.sw-no{margin-top:12px;background:none;border:0;color:#7a6654;font-size:13px;text-decoration:underline;cursor:pointer;font-family:inherit}' +
    '.sw-fine{font-size:11px;color:#8a7766;margin:12px 0 0;line-height:1.4;max-width:300px}' +
    '.sw-err{font-size:13px;color:#a12b2b;margin:0;display:none}' +
    '.sw-code{display:flex;align-items:center;justify-content:center;gap:10px;margin:4px 0 14px;border:1px dashed #8c5a2b;border-radius:6px;padding:10px 16px;font-size:20px;letter-spacing:.18em;color:#8c5a2b;font-weight:600}' +
    '.sw-copy{border:0;background:#f3ece1;color:#3b2a1e;border-radius:20px;padding:6px 12px;font-size:12px;cursor:pointer;letter-spacing:normal;font-weight:400}' +
    '@media (max-width:480px){.sw-box{aspect-ratio:auto;padding:34px 22px}.sw-h{font-size:26px}.sw-h b{font-size:38px}}';

  function el(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstChild; }

  var lastFocus;
  function open(content) {
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var ov = el('<div class="sw-overlay" role="presentation"><div class="sw-box" role="dialog" aria-modal="true" aria-labelledby="sw-title"><button type="button" class="sw-x" aria-label="Close">&times;</button>' + content + '</div></div>');
    document.body.appendChild(ov);
    lastFocus = document.activeElement;
    requestAnimationFrame(function () { ov.classList.add('sw-open'); });
    var box = ov.querySelector('.sw-box');
    function close() {
      ov.classList.remove('sw-open');
      setTimeout(function () { ov.remove(); }, 250);
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { dismiss(); }
      if (e.key === 'Tab') {
        var f = box.querySelectorAll('button,input');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function dismiss() { var s = get(); if (!s.subscribed) { s.dismissed = Date.now(); set(s); } close(); }
    document.addEventListener('keydown', onKey);
    ov.addEventListener('click', function (e) { if (e.target === ov) dismiss(); });
    ov.querySelector('.sw-x').addEventListener('click', dismiss);
    var no = ov.querySelector('.sw-no'); if (no) no.addEventListener('click', dismiss);
    var focusTarget = box.querySelector('input') || box.querySelector('.sw-btn') || box.querySelector('.sw-x');
    setTimeout(function () { focusTarget.focus(); }, 60);
    return { box: box, close: close };
  }

  function signup() {
    var ret = location.pathname;
    var m = open(
      '<p class="sw-brand">Savaine</p>' +
      '<h2 class="sw-h" id="sw-title">Welcome<b>5% OFF</b></h2>' +
      '<p class="sw-p">Join our list and get 5% off your first order, applied automatically at checkout.</p>' +
      '<form class="sw-form" method="post" action="/contact#shuli-welcome" accept-charset="UTF-8" novalidate>' +
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="newsletter,welcome5">' +
      '<input type="hidden" name="return_to" value="' + ret + '">' +
      '<label for="sw-email" class="visually-hidden" style="position:absolute;left:-9999px">Email address</label>' +
      '<input id="sw-email" class="sw-in" type="email" name="contact[email]" placeholder="Your email address" autocomplete="email" required>' +
      '<p class="sw-err" role="alert">Please enter a valid email address.</p>' +
      '<button type="submit" class="sw-btn">Get my 5% off</button>' +
      '</form>' +
      '<button type="button" class="sw-no">No thanks</button>' +
      '<p class="sw-fine">By signing up you agree to receive emails from Savaine. Unsubscribe anytime.</p>'
    );
    var form = m.box.querySelector('form');
    form.addEventListener('submit', function (e) {
      var v = form.querySelector('.sw-in').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { e.preventDefault(); form.querySelector('.sw-err').style.display = 'block'; return; }
      var s = get(); s.pending = Date.now(); set(s);
    });
  }

  function success() {
    var s = get(); s.subscribed = Date.now(); delete s.pending; set(s);
    fetch('/discount/' + CODE, { credentials: 'same-origin' }).catch(function () {});
    var m = open(
      '<p class="sw-brand">Savaine</p>' +
      '<h2 class="sw-h" id="sw-title">You’re in!<b>5% OFF</b></h2>' +
      '<p class="sw-p">Your discount is saved and will be applied automatically at checkout. Here’s your code, just in case:</p>' +
      '<div class="sw-code"><span>' + CODE + '</span><button type="button" class="sw-copy">Copy</button></div>' +
      '<button type="button" class="sw-btn" style="padding:0 34px">Start shopping</button>'
    );
    m.box.querySelector('.sw-copy').addEventListener('click', function () {
      var b = this;
      try { navigator.clipboard.writeText(CODE).then(function () { b.textContent = 'Copied'; }); } catch (e) {}
    });
    m.box.querySelector('.sw-btn').addEventListener('click', function () { m.close(); });
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
  }

  function start() {
    if (justPosted) { success(); return; }
    var s = get();
    if (s.pending && Date.now() - s.pending < 10 * 60 * 1000 && /customer_posted=true/.test(location.search)) { success(); return; }
    setTimeout(signup, DELAY_MS);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
